import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { WorkingStepDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectState } from '../../../../store/Project/ProjectTypes'

export const addWorkingStepToBomItem: CaseReducer<
  ProjectState,
  PayloadAction<{
    bomItemId: string
    workingStep: WorkingStepDto
  }>
> = (state, action) => {
  if (action.payload.bomItemId === state.activeProject?.id) {
    state.activeProject.workingSteps.push(action.payload.workingStep)
    return state
  }

  const bomItem =
    state.flatView[action.payload.bomItemId] ||
    state.treeView[action.payload.bomItemId]

  switch (bomItem?.type) {
    case 'AssemblyHeader': {
      bomItem.assembly.assemblyWorkingStepDtos.push(action.payload.workingStep)
      break
    }
    case 'Assembly':
    case 'Row': {
      bomItem.workingSteps.push(action.payload.workingStep)
      break
    }
  }

  return state
}
